import styled from "styled-components/macro";

export const CardFlexWrapperStyles = styled.div`
  display: flex;
  gap: 16px;
`;

export const TableWrapperStyles = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding: 8px 0 0 0;

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    .search-dropdown-styles {
      display: flex;

      .search-input {
        border-radius: 0 24px 24px 0;
        border-right: none;
      }

      .search-select {
        border-radius: 24px 0 0 24px;

        input {
          padding: 8px;
        }
      }
    }
  }
`;

export const CardWrapperStyles = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;

  .card-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    svg {
      width: 16px;
      height: 16px;
    }

    .card-title {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.014px;
    }
  }

  .card-count {
    color: var(--Neutral-100);
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.04px;
  }
`;
